import { resolveEnvironment, type Environment } from "@vellum/micro-app-auth";

const HUB_URLS: Record<Environment, string> = {
  local: "http://hub.local.vibestack.cloud",
  dev: "https://hub.dev.vellum.health",
  prod: "https://hub.vellum.health",
};

export function getHubUrl(): string {
  return HUB_URLS[resolveEnvironment()];
}

const LUNA_URLS: Record<Environment, string> = {
  local: "http://luna.local.vibestack.cloud",
  dev: "https://app.dev.vellum.health",
  prod: "https://app.vellum.health",
};

export function getLunaUrl(): string {
  return LUNA_URLS[resolveEnvironment()];
}

/**
 * Luna's company details page, deep linked to its Contacts tab.
 *
 * The `#contacts` hash is read by the `useHashTab` hook on that page, so this
 * lands on Contacts rather than the default Edit Company tab.
 */
export function getCompanyContactsUrl(companyId: string): string {
  return `${getLunaUrl()}/companies/${companyId}#contacts`;
}
